import React from "react";
import DataTable from 'react-data-table-component';

import Popup from "react-popup";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

export const SolicitudesDetalle = ({ data, detalle }) => {

  const notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });



  const getColumnDetalle = () => {
    return [
      {
        name: "Estado",
        selector: row => row.descripcionEtapa

      },
      {
        name: "Fecha Estado",
        selector: row => row.fechaInicio
      }
    ];
  }

  return (
    <DataTable
      noHeader={true}
      pagination={true}
      columns={getColumnDetalle()}
      data={data.detalle}
      dense={true}
      paginationComponentOptions={paginationOptions}
      noDataComponent="SIN DATOS"
      responsive={true}
      striped={true} />
  );

}